/*eslint-disable */
import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi, Container, Dropdown, TextArea,Divider,Header,Radio } from "semantic-ui-react";
import { translate } from "react-i18next";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import { DateData } from "../dynamicComponent/datepick";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import { AllRegex } from "../../utils/validation";
import AddCity from "../dynamicComponent/addCity";
import LrSeriesTable from './lrSeriesTable'
import { REQUIRED_FIELDS,INVALID_FIELDS,PROMPTS } from "../../utils/validationConstant";
import { FEATURES, getFieldLength } from "../../utils/constant";
import CategoryList from "../dynamicComponent/categoryList";

const InsertBranches = ({
  values,
  setFieldValue,
  t,
  touched,
  errors,
  handleSubmit,
  editData,
  LrSeriesData,
  ...props
}) => {
  const [networkCard, setnetworkCard] = useState([]);
  const [exemptedReason, setExemptedReason] = useState([]);

  const chargeMechanismOption = [{
    id:1,
    text:"Forward Charging Mechanism",
    value:"FCM",
    key:1
},{
    id:2,
    text:"Reverse Charging Mechanism",
    value:"RCM",
    key:2
}]
let options = []
    if (exemptedReason.length > 0) {
      exemptedReason.map((object, index) => {
            let temp = {}
            temp.key = object.GSTExemptedReasonId
            temp.text = object.GSTExemptedReasonName
            temp.value = object.GSTExemptedReasonId
            return options[index] = temp
        })
    }
    let fetchGSTExemptedReason=()=>{
      ReadAxios({ url: `gstExemptedReason` }).then((result) => {
        setExemptedReason(result.data.resultSet)
        console.log(result.data.resultSet);
      })
    }
  useEffect(() => {
    getnetworkCardList();
    fetchGSTExemptedReason();
  }, []);
  let fetchCityInfo = (data) => {
    setlat(data.lattitude)
    setlong(data.longitude)
  }

  const getnetworkCardList = async () => {
    let dataArray = await ReadAxios({ url: "networkProviderMaster" });
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    dataArray = dataArray.map((item, index) => {
      return {
        key: item.networkProviderCode,
        text: item.networkProviderName,
        value: item.networkProviderMasterId,
        raw: { ...item, index },
      };
    });
    setnetworkCard(dataArray);
  };
   let max = new Date(`${currentYear}-12-31`)
  return networkCard ? (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group>
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.branch_code.title") || "Branch Code."}{" "}
                  </label>
                </FormUi.Field>
         
                <FormUi.Field
                  width={4}
                  error={
                    touched.branchCode && errors.branchCode ? true : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="branchCode"
                    placeholder={
                      t("create.branch_code.placeholder") || "Branch Code."
                    }
                    disabled = {editData.branchId? true:false}
                    maxLength={15}
                  />
                  {touched.branchCode && errors.branchCode ? <small className="text-danger">{errors.branchCode}</small> : ''}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
            
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.branch_name.title") || "Branch Name"}<b className="w3-text-red"> *</b>
                  </label>
                </FormUi.Field>
                
                <FormUi.Field
                  width={4}
                  error={touched.branchName && errors.branchName ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="branchName"
                    placeholder={
                      t("create.branch_name.placeholder") || "Branch Name"
                    }
                    maxLength={50}
                  />
                  {touched.branchName && errors.branchName ? <small className="text-danger">{errors.branchName}</small> : ''}
                </FormUi.Field>
                
              </FormUi.Group>

              <FormUi.Group>              
              <FormUi.Field width={2}>
                <label className="labelName">{t("create.pincode.title") || "Pincode"}</label>
              </FormUi.Field>
              <FormUi.Field width={4} error={touched.pincode && errors.pincode ? true : false} >
              <Fieldmik
                    type="text"
                    className="ui input"
                    name="pincode"
                    placeholder={
                      t("create.pincode.placeholder") || "Pincode"
                    }
                  />
                   {touched.pincode && errors.pincode ? <small className="text-danger">{errors.pincode}</small> : ''}
                  </FormUi.Field>
                <FormUi.Field width="2"/>
          
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.pan_no.title") || "PAN Number"}
                  </label>
                </FormUi.Field>
              <FormUi.Field
                  width={4}
                  error={touched.panNo && errors.panNo ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="panNo"
                    placeholder={
                      t("create.pan_no.placeholder") || "PAN Number"
                    }
                    disabled={editData.panNo? true :false}
                  />
                  {touched.panNo && errors.panNo ? <small className="text-danger">{errors.panNo}</small> : ''}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group>              
              <FormUi.Field width={2}>
                <label className="labelName">{t("create.city.title") || "City"}</label>
              </FormUi.Field>
              <FormUi.Field width={4}>
              <Fieldmik
                  type="text"
                  className="cty"
                  component={AddCity}
                  stateName="stateName"
                  getCityInfo={fetchCityInfo}
                  name="cityId"
                  placeholder={editData.cityName ||t("create.city.placeholder")}
                  stateFilterId={editData?.stateId ? editData?.stateId : null}
                  //value={values.cityId}
                />
                  </FormUi.Field>
                <FormUi.Field width="2"/>
            
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.state.title") || "State"}
                  </label>
                </FormUi.Field>
              <FormUi.Field
                  width={4}
                  error={touched.stateName && errors.stateName ? true : false}
                >
                  <Fieldmik
                    type="text"
                    name="stateName"
                    readOnly={true}
                    placeholder={
                    t("create.state.placeholder") || "State Name"
                    }
                  />
                  {touched.stateName && errors.stateName ? <small className="text-danger">{errors.stateName}</small> : ''}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group>              
              <FormUi.Field width={2}>
                <label className="labelName">{t("create.contact_person_name.title") || "Contact Person"}{" "}{FEATURES.branchContactPersonMandatory && <b className="w3-text-red"> *</b>} </label>
              </FormUi.Field>
              <FormUi.Field width={4} error={touched.contactPersonName && errors.contactPersonName ? true : false} >
              <Fieldmik
                    type="text"
                    className="ui input"
                    name="contactPersonName"
                    placeholder={
                      t("create.contact_person_name.placeholder") || "Contact Person"
                    }
                  />
                   {touched.contactPersonName && errors.contactPersonName ? <small className="text-danger">{errors.contactPersonName}</small> : ''}
                  </FormUi.Field>
                <FormUi.Field width="2"/>
          
              <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.contact_person_no.title") || "Contact Person Number"} {" "}{FEATURES.branchContactPersonMandatory && <b className="w3-text-red"> *</b>}
                  </label>
                </FormUi.Field>
              <FormUi.Field
                  width={4}
                  error={touched.contactPersonMobileNo && errors.contactPersonMobileNo ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="contactPersonMobileNo"
                    placeholder={
                      t("create.contact_person_no.placeholder") || "Contact Person Number"
                    }
                  />
                  {touched.contactPersonMobileNo && errors.contactPersonMobileNo ? <small className="text-danger">{errors.contactPersonMobileNo}</small> : ''}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group>
              
              <FormUi.Field width={2}>
                <label className="labelName">{t("create.address.title") || "Address"}</label>
              </FormUi.Field>
              
              <FormUi.Field width={4}>
              <Fieldmik
                  as={TextArea}
                  className="ui input"
                  name="address"
                  placeholder={editData.address||t("create.address.title")}
                  maxLength={250}
                  
                />
              </FormUi.Field>
              </FormUi.Group>
              <Divider horizontal>
                <Header as='h4'>
                {t("GST_Details") }
                </Header>
              </Divider>
              <FormUi.Group>
                <FormUi.Field width="2">
                  <label className="labelName mt-2">{t("Is_GST_Applicable") }</label>
                </FormUi.Field>
                
                  <FormUi.Field width={2}>
                    <Radio label="No" className='mt-2' name='isGSTApplicable' value='No'
                      checked={values.isGSTApplicable === false} onChange={() => { 
                      setFieldValue("isGSTApplicable", !values.isGSTApplicable)
                      if(editData?.isGSTApplicable !== 'Yes'){
                        setFieldValue("gstNo", ""),
                        setFieldValue("gstChargeMechanism", ""),
                        setFieldValue("GSTExemptedReasonId", ""),
                        setFieldValue("validityStartDate", new Date(`${fromYear}-04-01`)),
                        setFieldValue("validityEndDate", new Date(`${toYear}-03-31`))
                        setFieldValue("isGSTExempted",false )
                      }
                      }} />
                  </FormUi.Field>
                  <FormUi.Field width={2}>
                    <Radio label="Yes" className='mt-2' name='isGSTApplicable' value='Yes'
                      checked={values.isGSTApplicable === true} onChange={() => { setFieldValue("isGSTApplicable", !values.isGSTApplicable) }} />
                  </FormUi.Field>


                {
                  values.isGSTApplicable  ?
                    <>
                    <FormUi.Field width="2" />
                    
                     <FormUi.Field width="2" >
                          <label className="labelName">{t("GST_Number") } <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4" error={touched.gstNo && errors.gstNo ? true : false} disabled={editData?.gstNo ? true : false}>
                          <Fieldmik name="gstNo" component={MyNormalInput}  placeholder = {t("GST_Number")}/>
                          {touched.gstNo && errors.gstNo ? <small className="text-danger">{errors.gstNo}</small> : ''}
                        </FormUi.Field>
                     
                    </> : null
                }
              </FormUi.Group>
              
              {values.isGSTApplicable?
              <>
                <FormUi.Group>
              <FormUi.Field width={2}>
                          <label>{t("Charge_Mechanism.title")}{"   "} </label>
                        </FormUi.Field>
                        <FormUi.Field width={4}>
                          <Dropdown
                            name="gstChargeMechanism"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            selection
                            placeholder={t("Charge_Mechanism.placeholder")}
                            value={values.gstChargeMechanism}
                            options={chargeMechanismOption}
                            onChange={(name, data) => {
                              setFieldValue("gstChargeMechanism", data.value);
                            }}
                          />
                        </FormUi.Field>
              </FormUi.Group>
 
              <FormUi.Group> 
                      <FormUi.Field width={2}>
                        <label>{t("DatePick.validityStartDate") }</label>
                      </FormUi.Field>
                      <FormUi.Field width={4}>
                        <DateData
                          name="validityStartDate"
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd/MM/yyyy"
                          maxDate=  {new Date(values.validityEndDate).getFullYear() == currentYear?values.validityEndDate:max}
                          value = {values.validityStartDate}
                        />
                        {touched.gstValidityStartDate && errors.gstValidityStartDate ? <small className="text-danger">{errors.gstValidityStartDate}</small> : ''}
                      </FormUi.Field>
                      <FormUi.Field width={2} />
                      <FormUi.Field width={2}>
                        <label>{t("DatePick.validityEndDate") }</label>
                      </FormUi.Field>
                    
                      <FormUi.Field width={4}>
                        <DateData
                          name="validityEndDate"
                          autoComplete="off"
                          popperClassName="dateTime"
                          dateFormat="dd/MM/yyyy"
                          minDate={values.validityStartDate}
                          value = {values.validityStartDate == null ?values.validityEndDate="":values.validityEndDate}
                          disabled = {values.validityStartDate == null ? true :false}
                          />
                      </FormUi.Field>
                    </FormUi.Group> 


               <FormUi.Group>
                
                      <FormUi.Field width="2">
                        <label className="labelName mt-2">{t("Is_GST_Exempted")}</label>
                      </FormUi.Field>
                      <FormUi.Field width="2">
                        <Radio label="No" className='mt-2' name='isGSTExempted' value='No'
                          checked={values.isGSTExempted === false } onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) ,setFieldValue("GSTExemptedReasonId","")}} />
                      </FormUi.Field>
                      <FormUi.Field width="2">
                        <Radio label="Yes" className='mt-2' name='isGSTExempted' value='Yes'
                          checked={values.isGSTExempted  === true} onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) }} />
                      </FormUi.Field>
                
                      {values.isGSTExempted ?
                        <>
                          <FormUi.Field width="2" />
                          
                          <FormUi.Field >
                            <label>{t("Gst_exempted_reason")} <b className="w3-text-red"> *</b></label>
                          </FormUi.Field>
                          <FormUi.Field width={4} error={touched.GSTExemptedReasonId && errors.GSTExemptedReasonId ? true : false}>
                            <Dropdown
                              name="GSTExemptedReasonId"
                              clearable
                              style={{ width: "100%", fontWeight: "normal" }} 
                              selection
                              placeholder="--SELECT A REASON--"
                              value={values.GSTExemptedReasonId}
                              options={options}
                              onChange={(name, data) => {
                                setFieldValue("GSTExemptedReasonId", data.value);
                              }}
                              
                            />
                           {touched.GSTExemptedReasonId && errors.GSTExemptedReasonId ? <small className="text-danger">{errors.GSTExemptedReasonId}</small> : ''}
                          </FormUi.Field>

                        </>:null
                      }
                      
              </FormUi.Group>
              </>:null
              }


            <Divider horizontal>
                <Header as='h4'>
                {t("service_category_details") || "Service Category Details"}
                </Header>
              </Divider>
           <FormUi.Group>
              <FormUi.Field width={2}>
                <label className="labelName">{t("create.service_category.title") || "Service Category"}</label>
              </FormUi.Field>
              <FormUi.Field width={4}
              error={touched.serviceCategoryId && errors.serviceCategoryId ? true : false} >
              <Fieldmik
                    type="text"
                    className="ui input"
                    name="serviceCategoryId"
                    placeholder={
                      values.serviceCategory || t("create.service_category.placeholder") || "Select Service Category"
                    }
                    component={CategoryList}
                    value={values.serviceCategoryId}
                    disabled={editData?.serviceCategoryId ? true :false}
                  />
                  {console.log(editData?.serviceCategoryId,'rowdata344')}
                {touched.serviceCategoryId && errors.serviceCategoryId ? <small className="text-danger">{errors.serviceCategoryId}</small> : ''}
                </FormUi.Field>
                <FormUi.Field width={2}/>
                <FormUi.Field width={2}>
                  <label className="labelName">
                  {t("create.cost_center.title") || "Cost Center"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  error={touched.costCenter && errors.costCenter ? true : false}
                >
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="costCenter"
                    placeholder={
                      t("create.cost_center.placeholder") || "Cost Center"
                    }
                    maxLength={30}
                  />
                  {touched.costCenter && errors.costCenter ? <small className="text-danger">{errors.costCenter}</small> : ''}
                </FormUi.Field>
              </FormUi.Group>
           

            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
     {FEATURES.lr_series_activated && editData.branchId &&
      <LrSeriesTable branchId={editData.branchId} branchCode={editData.branchCode} LrSeriesData={LrSeriesData} />}
    </React.Fragment>
  ) : (
    <LoadingPlaceholder />
  );
};
let currentYear = new Date().getFullYear()
let currentMonth = new Date().getMonth()
let fromYear =currentMonth <4?currentYear -1:currentYear
let toYear = fromYear+1
const FormikBranches = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    branchCode: yup
      .string()
      .optional().max(getFieldLength("branchCode") || 15,INVALID_FIELDS.INVALID_MAXIMUMSIZE(getFieldLength("branchCode") || 15)).nullable(),
    branchName: yup
      .string()
      .required(REQUIRED_FIELDS.BRANCH_NAME).max(50,INVALID_FIELDS.MAX_SIZE_50).nullable(),
    gstNo:yup
    .string().matches(AllRegex.GSTIN, INVALID_FIELDS.INVALID_GST_NUMBER).nullable()
    .when("isGSTApplicable",{is: true,then:yup.string().required(REQUIRED_FIELDS.GST_NO_REQUIRED).nullable()}) 
    ,
    GSTExemptedReasonId:yup
    .string()
    .when("isGSTExempted",{is: true,then:yup.string().required(REQUIRED_FIELDS.GST_EXEMPTED_REQUIRED).nullable()}) 
    ,
    cityId: yup.string().optional().nullable(),
    address: yup.string().optional().nullable(),
    pincode : yup.string().optional().nullable().matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE),
    panNo : yup.string().optional().nullable().matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER),
    stateName:yup.string().optional().nullable(),
    serviceCategoryId : yup.string().optional().nullable(),
    costCenter : yup.string().optional().nullable().matches(AllRegex.WITHOUT_SPECIAL_CHARECTERS_AND_SPACE, INVALID_FIELDS.INVALID_FIELD('Cost Center')),
    contactPersonName : FEATURES.branchContactPersonMandatory ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(50,INVALID_FIELDS.MAX_SIZE_50).nullable() : yup.string().optional().max(50,INVALID_FIELDS.MAX_SIZE_50).nullable(),
    contactPersonMobileNo : FEATURES.branchContactPersonMandatory ? yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_FIELD('Mobile Number')) : yup.string().optional().nullable().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_FIELD('Mobile Number')),

  }),
  mapPropsToValues: (props) => {
    return {
      branchCode: props.editData.branchCode || "",
      branchName: props.editData.branchName || "",
      cityId: props.editData.cityId || "",
      stateName : props.editData.stateName || "",
      pincode: props.editData.pincode || "",
      panNo : props.editData.panNo ||"",
      address: props.editData.address || "",
      isGSTApplicable :props.editData.branchId?(props.editData.isGSTApplicable === 'Yes' ? true :false ):true,
      isGSTExempted : props.editData.isGSTApplicable === 'Yes' && props.editData.isGSTExempted === 'Yes' ? true :false  ,
      gstChargeMechanism : props.editData.isGSTApplicable === 'Yes'? (props.editData.gstChargeMechanism  || ""):"" ,
      gstNo :props.editData.isGSTApplicable === 'Yes'? (props.editData.gstNo || ""):"",
      GSTExemptedReasonId : (props.editData.isGSTApplicable === 'Yes' && props.editData.isGSTExempted === 'Yes' && props.editData.GSTExemptedReasonId) || "",
      validityStartDate: props?.editData?.branchId ? (props?.editData?.validityStartDate ? new Date(props.editData.validityStartDate) :"" ): new Date(`${fromYear}-04-01`),
      validityEndDate: props?.editData?.branchId ? (props?.editData?.validityEndDate ? new Date(props.editData.validityEndDate) : "" ) : new Date(`${toYear}-03-31`),
      serviceCategoryId : props.editData.serviceCategoryId || "",
      serviceCategory : props.editData.serviceCategory || "",
      costCenter : props.editData.costCenter || "",
      contactPersonName : props?.editData?.contactPersonName || "",
      contactPersonMobileNo : props?.editData?.contactPersonMobileNo || ""
    };
  },
  async handleSubmit(values, { props }) {
    if(values.validityStartDate && values.validityEndDate && values.validityStartDate >  values.validityEndDate){
      let alert = {
        type: "error",
        messageHeader: "Error",
        messageBody: PROMPTS.VALIDITY_ENDDATE_SHOULD_GREATER,
      };
      props.errorAlertDispatcher(alert);
      return ;
    }
    if(props?.editData?.validityStartDate && props?.editData?.validityEndDate && new Date() <  new Date(props?.editData?.validityEndDate)){
      let isGSTApplicable = props.editData.isGSTApplicable === 'Yes'? true : false
      let isGSTExempted = props.editData.isGSTExempted === 'Yes'? true : false
      if(isGSTApplicable !== values.isGSTApplicable){
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('Is GST Applicable value'),
        };
        props.errorAlertDispatcher(alert);
        return ;
      }
      if(props?.editData?.gstChargeMechanism !== values.gstChargeMechanism){
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('GST Charge Mechanism'),
        };
        props.errorAlertDispatcher(alert);
        return ;
      }
      if(isGSTExempted !== values.isGSTExempted){
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('Is GST Exempted value'),
        };
        props.errorAlertDispatcher(alert);
        return ;
      }
    }
      if (props.editData.branchId) {
        if(values.gstChargeMechanism){
          if(!values.validityStartDate){
            values.validityStartDate = new Date(`${fromYear}-04-01`)
          }
          if(!values.validityEndDate){
            values.validityEndDate = new Date(`${toYear}-03-31`)
          }
        }
        await UpdateAxios({
          url: "branch",
          payload: { ...values },
          uniqueId: props.editData.branchId,
        })
          .then((res) => {
            if(res.data.status === 200){
              if(values.serviceCategoryId && values.costCenter && props.editData.branchId){
                try{
                  let payload = {
                    branchId : props.editData.branchId,
                    serviceCategoryId : values.serviceCategoryId,
                    costCenter : values.costCenter
                  }
                  let mappingResponse = CreateAxios({
                    completeURL: `${process.env.REACT_APP_MASTER_API}/insertupdateBrachServiceCategoryMapping`,
                    payload
                  })
                  if(mappingResponse?.data?.status !== 200){
                    let alert = {
                      type: "error",
                      messageHeader: "Error",
                      messageBody: mappingResponse?.data?.message||"Unable to add service category details",
                    };
                    props.errorAlertDispatcher(alert);
                  }
                }catch(err){
                  console.log(err);
                }
              }
              let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: res.data.message||"Branch successfully updated",
              };
              props.successAlertDispatcher(alert);
              props.onFormSubmit();
            }else{
              let alert = {
                type: "error",
                messageHeader: "Error",
                messageBody: err?.data?.message||"Unable to update branch",
              };
              props.errorAlertDispatcher(alert);
            }
          })
          .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: err.data.message,
            };
            console.log(err);
            props.errorAlertDispatcher(alert);
          });
      } else {
        await CreateAxios({
          url: "branch",
          payload: { ...values },
        })
          .then((res) => {
            if(res.data.status === 200){
              if(values.serviceCategoryId && values.costCenter && res.data.branchId){
                try{
                  let payload = {
                    branchId : res.data.branchId,
                    serviceCategoryId : values.serviceCategoryId,
                    costCenter : values.costCenter
                  }
                  let mappingResponse = CreateAxios({
                    completeURL: `${process.env.REACT_APP_MASTER_API}/insertupdateBrachServiceCategoryMapping`,
                    payload
                  })
                  if(mappingResponse?.data?.status !== 200){
                    let alert = {
                      type: "error",
                      messageHeader: "Error",
                      messageBody: mappingResponse?.data?.message||"Unable to add service category details",
                    };
                    props.errorAlertDispatcher(alert);
                  }
                }catch(err){
                  console.log(err);
                }
              }
              let alert = {
                type: "success",
                messageHeader: "Success",
                messageBody: res.data.message||"Branch successfully created",
              };
              props.successAlertDispatcher(alert);
              props.onFormSubmit();
            }else{
              let alert = {
                type: "error",
                messageHeader: "Error",
                messageBody: err?.data?.message||"Unable to create branch",
              };
              props.errorAlertDispatcher(alert);
            }
            
          })
          .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: err?.data?.message||"Unable to create branch",
            };
            props.errorAlertDispatcher(alert);
          });
      }
  },
})(InsertBranches);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allbranch")(FormikBranches)
);
